import { render, staticRenderFns } from "./ResultLayout.vue?vue&type=template&id=75eda560&"
import script from "./ResultLayout.vue?vue&type=script&lang=js&"
export * from "./ResultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports